import React from "react";
import MaInput from "../../../../Components/UI/ma-input";
import { InputAdornment, MenuItem } from "@mui/material";
import { LuSearch } from "react-icons/lu";
import { PRODUCT_FILTER_MENU_PROPS } from "../products/product-filter-menu-styles";

const FILTER_SELECT_PROPS = {
  MenuProps: PRODUCT_FILTER_MENU_PROPS,
};

export function CustomersToolbar({
  search,
  onSearchChange,
  statusFilter = "",
  onStatusFilterChange,
  categoryFilter = "",
  onCategoryFilterChange,
}) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:mb-6">
      <div className="w-full md:w-[35%] md:min-w-[200px]">
        <MaInput
          fullWidth
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search customers..."
          borderColor="#E5E7EB"
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <LuSearch className="text-[20px] text-[#9CA3AF]" />
                </InputAdornment>
              ),
            },
          }}
        />
      </div>

      <div className="grid grid-cols-2 gap-3 md:hidden">
        <MaInput
          select
          fullWidth
          value={statusFilter}
          onChange={(e) => onStatusFilterChange?.(e.target.value)}
          SelectProps={FILTER_SELECT_PROPS}
          borderColor="#E5E7EB"
        >
          <MenuItem value="">Status</MenuItem>
        </MaInput>
        <MaInput
          select
          fullWidth
          value={categoryFilter}
          onChange={(e) => onCategoryFilterChange?.(e.target.value)}
          SelectProps={FILTER_SELECT_PROPS}
          borderColor="#E5E7EB"
        >
          <MenuItem value="">Category</MenuItem>
        </MaInput>
      </div>
    </div>
  );
}
